<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Bloques</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    Carga Seca
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Bloques</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-12">
                    <div class="btn-group float-right">
                      <!-- SE LLAMA AL MODAL DE BLOQUE EXPORT -->
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_lista_bloques"
                        v-if="$store.getters.can('cs.bloques.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        v-if="$store.getters.can('cs.bloques.create')"
                        @click="create()"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="form-group col-md-4">
                    <label>Bloque:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.bloque"
                      @keypress.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Prefijo:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.prefijo"
                      @keypress.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Código:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.codigo"
                      @keypress.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Pais:</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.pais"
                      label="nombre"
                      :options="listasForms.paises"
                      :reduce="(d) => d.id"
                      @input="getIndex()"
                    >
                    </v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Departamento:</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.departamento"
                      label="descripcion"
                      :options="listasForms.departamentos"
                      :reduce="(d) => d.id"
                      @input="getIndex()"
                    >
                    </v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Ciudad:</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.ciudad"
                      label="nombre"
                      :options="listasForms.ciudades"
                      :reduce="(c) => c.id"
                      @input="getIndex()"
                    >
                    </v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Dirección:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.direccion"
                      @keypress.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Estado:</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.estado"
                      label="descripcion"
                      :options="listasForms.estados"
                      :reduce="(e) => e.id"
                      @input="getIndex()"
                    >
                    </v-select>
                  </div>
                  <div class="form-group text-right col-md-2">
                    <div class="btn-group pt-4">
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-search"></i></button
                      ><button
                        type="button"
                        class="btn btn-danger"
                        @click="limpiarForm()"
                      >
                        <i class="fas fa-broom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead class="bg-dark">
                    <tr>
                      <th>Bloque</th>
                      <th class="col-1">Prefijo</th>
                      <th class="col-1">Código</th>
                      <th>Dirección</th>
                      <th class="col-1">Estado</th>
                      <th class="col-1">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bloque in bloques.data" :key="bloque.id">
                      <td>{{ bloque.nombre }}</td>
                      <td>{{ bloque.prefijo }}</td>
                      <td>{{ bloque.codigo }}</td>
                      <td>
                        <p class="m-0">
                          {{ bloque.direccion }}
                        </p>
                        <small class="text-muted m-0">
                          {{ bloque.ciudad.nombre ?? "" }}
                          {{
                            bloque?.departamento?.descripcion
                              ? ` - ${bloque.departamento.descripcion}`
                              : ""
                          }}
                          {{
                            bloque?.pais?.nombre
                              ? ` (${bloque.pais.nombre})`
                              : ""
                          }}
                        </small>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          v-bind:class="[
                            bloque.estado == 1
                              ? 'badge-success'
                              : 'badge-danger',
                          ]"
                        >
                          {{ bloque.nEstado }}
                        </span>
                      </td>
                      <td>
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('cs.bloques.show')"
                            @click="edit(bloque.id)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="$store.getters.can('cs.bloques.delete')"
                            @click="destroy(bloque.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="bloques.total">
                  Mostrando del <b>{{ bloques.from }}</b> al
                  <b>{{ bloques.to }}</b> de un total:
                  <b>{{ bloques.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </div>
                <pagination
                  :data="bloques"
                  @pagination-change-page="getIndex"
                  :limit="3"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
        <BloqueExport ref="BloqueExport" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../../../components/Loading";
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import pagination from "laravel-vue-pagination";
import BloqueExport from "./BloqueExport";

export default {
  name: "CsBloqueIndex",
  components: {
    Loading,
    vSelect,
    pagination,
    BloqueExport,
  },
  data() {
    return {
      cargando: false,
      filtros: {
        bloque: null,
        prefijo: null,
        codigo: null,
        pais: null,
        departamento: null,
        ciudad: null,
        direccion: null,
        estado: null,
      },
      bloques: {},
      listasForms: {
        paises: [],
        departamentos: [],
        ciudades: [],
        estados: [],
      },
      modal: {
        title: "",
      },
    };
  },
  validations() {
    if (this.form.estado == 1) {
      return {
        form: {
          estado: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          estado: {
            required,
          },
          justificacion: {
            required,
          },
        },
      };
    }
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/cs/bloques?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.cargando = false;
          this.bloques = response.data;
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    limpiarForm() {
      this.filtros = {
        bloque: null,
        prefijo: null,
        codigo: null,
        pais: null,
        departamento: null,
        ciudad: null,
        direccion: null,
        estado: null,
      };
      this.getIndex();
    },
    getPaises() {
      axios.get("/api/admin/paises/lista").then((response) => {
        this.listasForms.paises = response.data;
      });
    },
    getDepartamentos() {
      axios.get("/api/admin/departamentos/lista").then((response) => {
        this.listasForms.departamentos = response.data;
      });
    },
    getCiudades() {
      axios.get("/api/admin/ciudades/lista").then((response) => {
        this.listasForms.ciudades = response.data;
      });
    },
    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },
    destroy(id) {
      this.$swal({
        title: "Está seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.cargando = true;
          axios.delete("/api/cs/bloques/" + id).then((response) => {
            this.cargando = false;
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se eliminó el item exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
        }
      });
    },
    create() {
      return this.$router.push({
        name: "/Cs/BloquesForm",
      });
    },
    edit(id) {
      return this.$router.push({
        name: "/Cs/BloquesForm",
        params: { id },
      });
    },
  },

  beforeMount() {
    this.getPaises();
    this.getDepartamentos();
    this.getCiudades();
    this.getEstados();
  },

  mounted() {
    this.getIndex();
  },
};
</script>
